export const DATA_CARD_COLORS = {
  DEFAULT: null,
  DANGER: 'danger',
  MUTED: 'muted',
};
